
import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { ArrowRight, Calendar, Heart } from "lucide-react";

const New2FinalCTA = () => {
  const { language } = useLanguage();
  
  const content = {
    fr: {
      title: "Prêt à créer un moment qui marquera sa vie ?",
      subtitle: "Rejoignez les 1000+ familles qui ont déjà choisi Legatia",
      description: "Ne laissez pas le temps passer sans agir. Chaque jour qui passe est une opportunité manquée de créer quelque chose de beau pour votre enfant.",
      cta: "Créer leur cagnotte cadeau",
      consultation: "Consultation gratuite",
      guarantee: "30 jours satisfait ou remboursé • Aucun engagement"
    },
    en: {
      title: "Ready to create a moment that will mark their life?",
      subtitle: "Join the 1000+ families who have already chosen Legatia",
      description: "Don't let time pass without acting. Every day that passes is a missed opportunity to create something beautiful for your child.",
      cta: "Create their first capsule",
      consultation: "Free consultation",
      guarantee: "30-day money-back guarantee • No commitment"
    },
    de: {
      title: "Bereit, einen Moment zu schaffen, der ihr Leben prägen wird?",
      subtitle: "Schließen Sie sich den 1000+ Familien an, die Legatia bereits gewählt haben",
      description: "Lassen Sie die Zeit nicht verstreichen, ohne zu handeln. Jeder Tag, der vergeht, ist eine verpasste Gelegenheit, etwas Schönes für Ihr Kind zu schaffen.",
      cta: "Erste Kapsel erstellen",
      consultation: "Kostenlose Beratung",
      guarantee: "30 Tage Geld-zurück-Garantie • Keine Verpflichtung"
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-legatia-orange via-legatia-red to-legatia-orange relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10">
        <div className="absolute top-20 right-20 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-48 h-48 bg-white rounded-full blur-2xl"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-4xl mx-auto text-white">
          <div className="flex justify-center mb-6">
            <Heart className="h-16 w-16 text-white opacity-80" />
          </div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            {content[language].title}
          </h2>
          
          <p className="text-xl md:text-2xl mb-4 opacity-90">
            {content[language].subtitle}
          </p>
          
          <p className="text-lg mb-12 opacity-80 max-w-2xl mx-auto">
            {content[language].description}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-8">
            <Button 
              size="lg"
              className="bg-white text-legatia-orange hover:bg-gray-100 px-10 py-6 text-xl rounded-full shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all"
              onClick={() => window.location.href = "https://app.getlegatia.ch/"}
            >
              {content[language].cta}
              <ArrowRight className="ml-2 h-6 w-6" />
            </Button>
            
            <Button 
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-legatia-orange px-10 py-6 text-xl rounded-full"
              onClick={() => window.location.href = "https://calendly.com/legatia/15min"}
            >
              <Calendar className="mr-2 h-6 w-6" />
              {content[language].consultation}
            </Button>
          </div>
          
          <p className="text-sm opacity-75">
            {content[language].guarantee}
          </p>
        </div>
      </div>
    </section>
  );
};

export default New2FinalCTA;
